export const blockIconsMapsDirectionsWalk = (
	<span className='material-symbols-outlined'>directions_walk</span>
);
